// extracted by mini-css-extract-plugin
export default {"linqView":"SmartText_linqView__Uo8pr"};